import { AgendaEvent, Dossier, Fitter } from '@sc/data-access-models';
import { ResourceType } from './resource';

export interface ResourceExtendedProps {
  resId: string;
  brand: string;
  city: string;
  fitterId: string;
  isFirst: boolean;
  isLast: boolean;
  isGeneralFirst: boolean;
  isGeneralLast: boolean;
  timezone: string;
  type: ResourceType;
  fitterComment: string;
}

export interface CommonEventExtendedProps {
  fitter: Fitter;
  display: boolean;
}
export interface DossierEventExtendedProps extends CommonEventExtendedProps {
  dossier: Dossier;
}
export interface GenericEventExtendedProps extends CommonEventExtendedProps {
  event: AgendaEvent;
}
export type EventExtendedProps =
  | DossierEventExtendedProps
  | GenericEventExtendedProps;
